import { DivisionResultMetadata, EntryIntervalResult, IntervalResultMetadata } from '../types.results.reignite';
import transformReigniteEntryIntervalPace from './transformReigniteEntryIntervalPace';
import transformReigniteEntryIntervalTime from './transformReigniteEntryIntervalTime';

export default function transformReigniteIntervalResults({
  division,
  interval,
  results,
}: {
  division: DivisionResultMetadata;
  interval: IntervalResultMetadata;
  results: EntryIntervalResult[];
}) {
  return results.map(({
    chipTimeInMillis,
    gunTimeInMillis,
    id,
    rankings,
    ...pii
  }) => ({
    ...pii,
    entryId: id,
    genderRank: rankings.gender,
    intervalRaceType: interval.raceType,
    overallRank: rankings.overall,
    pace: transformReigniteEntryIntervalPace({
      chipTimeInMillis,
      division,
      gunTimeInMillis,
      interval,
    }),
    primaryBracketRank: rankings.primary,
    time: transformReigniteEntryIntervalTime({
      chipTimeInMillis,
      division,
      gunTimeInMillis,
      interval,
    })
  }));
}
